// import TranslatesContent from "../../../DataStore/Languages/translatesContent";
import { IMAGE_BUCKET_URL, SPORT_LOGIN_URL, POINTS_URL } from "../../../../DataStore/ApiConstant";
import axios from "axios";
import { useEffect, useState } from "react";

const yesterday = "2025-07-01";
const today = new Date().toISOString().split('T')[0];

const CouponModal = ({goToCashier, closePopup, login ,openPopup}) => {
    const [fromDate, setFromDate] = useState(yesterday);
    const [toDate, setToDate] = useState(today);
    const [pointsAvailable, setPointsAvailable] = useState("");
    let points = 0;

    useEffect(() => {
        if (fromDate && toDate) {
            axios
              .get(POINTS_URL + `?startdate=${fromDate}&enddate=${toDate}`)
              .then((resp) => {
                if (resp?.data?.points > 0) {
                    points = Math.floor(resp?.data?.points / 2500);
                    setPointsAvailable(points);
                }
              })
              .catch((err) => {});
        }
    }, [fromDate, toDate]);
    
    return ( 
    <>
    <div className="row">
        <div className="col-12 mainTitel">
            <img src={IMAGE_BUCKET_URL + "spin-for-freedom.jpg"}className="img-fluid" alt="" />
        </div>
        <div className="col-12">
            <div className="row">
            <div className="col-12">
                <h3>SPIN FOR FREEDOM COUPONS</h3>
            </div>
            <div className="col-12 mb-3">
                <div className="flip-number">
                    {String(pointsAvailable || 0).split('').map((digit, index) => (
                        <div className="flip-digit" key={index}>
                            <span className="digit">{digit}</span>
                        </div>
                    ))}
                </div>
            </div>
            <div className="col-12 mb-3 d-flex justify-content-center">
                <h4>Calculated 1st July 2025 To Day</h4>
            </div>
            <div className="col-12 mb-3 d-flex justify-content-center">
                <h4>* 2500 Points = 1 coupon</h4>
            </div>
            </div>
        </div>
        </div>
    </>
    );
}
 
export default CouponModal;